import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    marginHorizontal: 16.6,
    marginTop: 45,
  },
  calendarContainer: theme => ({
    paddingHorizontal: 16.6,
    paddingVertical: 24,
    marginHorizontal: 16.6,
    marginTop: 10,
    marginBottom: 50,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
  }),
  calendarMonth: theme => ({
    monthTextColor: theme.colors.boldTextColor,
    textMonthFontFamily: Fonts.type.bold.fontFamily,
    textMonthFontSize: 18.7,
    textMonthFontWeight: Fonts.type.bold.fontWeight,
  }),
  calendarDay: theme => ({
    textSectionTitleColor: theme.colors.textColorSix,
    textDayHeaderFontFamily: Fonts.type.VFFont,
    textDayHeaderFontSize: 14.6,
  }),
  calendarNumbers: theme => ({
    color: theme.colors.textColorFive,
    fontFamily: Fonts.type.VFFont,
    fontSize: 14.6,
    lineHeight: 22,
  }),
  calendarDisabledNumbers: {
    color: Colors.platinum,
  },
  calendarTodayContainer: theme => ({
    borderWidth: 1,
    borderColor: theme.colors.activeColor,
  }),
  calendarSelectedNumber: theme => ({
    color: theme.colors.cardBackgroundColor,
    ...Fonts.type.bold,
  }),
  calendarSelectedPeriod: theme => ({
    backgroundColor: theme.colors.fillColor,
    borderRadius: 0,
    width: '100%',
  }),
  calendarArrowStyle: direction => ({
    marginRight: direction === 'right' ? -15 : 0,
    marginLeft: direction === 'left' ? -15 : 0,
  }),
  selectedContainer: isVisible => ({
    alignItems: 'center',
    marginTop: 33.6,
    marginBottom: 16.4,
    opacity: !isVisible ? 0 : undefined,
  }),
  selectedTitle: {
    fontSize: 18.7,
  },
  selectedValue: {
    ...Fonts.type.bold,
    fontSize: 18.7,
    paddingTop: 4,
  },
  divider: theme => ({
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.horizontalLineColor,
    marginBottom: 17,
  }),
});
